import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf99dbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-2 bg-white flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start items-center ml-1 mr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bg-gray-400 rounded-full h-2 w-2 border border-gray-400" }),
  /*#__PURE__*/_createElementVNode("span", { class: "bg-gray-400 rounded-full h-2 w-2 border border-gray-400 ml-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "bg-gray-400 rounded-full h-2 w-2 border border-gray-400 ml-1" })
], -1))
const _hoisted_3 = { class: "flex justify-between items-center h-8 bg-light-3 rounded-md text-dark-3 flex-grow p-2" }
const _hoisted_4 = { class: "flex justify-start items-center" }
const _hoisted_5 = { class: "inline-flex items-center text-dark-2" }
const _hoisted_6 = { class: "overflow-y-auto max-h-96 overflow-x-hidden" }
const _hoisted_7 = { id: "emailPreviewWrapper" }
const _hoisted_8 = ["srcdoc"]
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_10 = { class: "flex flex-col justify-start items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-sm mb-8 mx-14 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_modal = _resolveComponent("app-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "hidden md:flex flex-col inline-block rounded-lg border border-light-3 overflow-hidden w-156 mr-22",
      key: _ctx.html
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_app_icon, {
              name: "GlobeAlt",
              size: "5",
              class: "mr-2"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.url), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createVNode(_component_app_icon, {
              name: "ExternalLink",
              size: "5",
              class: "cursor-pointer",
              onClick: _ctx.openPreviewInNewWindow
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                
                            _ctx.$t('components.mails.previewContent.openPreview')
                        ,
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_app_icon, {
              name: "Clipboard",
              size: "5",
              class: "cursor-pointer ml-4",
              onClick: _ctx.copyToClipboard
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                
                            _ctx.$t('components.mails.previewContent.copyUrl')
                        ,
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_app_icon, {
              name: "DeviceMobile",
              size: "5",
              class: "cursor-pointer ml-4",
              onClick: _ctx.openQRCodeModal
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                
                            _ctx.$t('components.mails.previewContent.openMobile')
                        ,
                void 0,
                { top: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("iframe", {
            id: "emailPreview",
            class: "frame",
            srcdoc: _ctx.html,
            sandbox: "allow-same-origin"
          }, null, 8, _hoisted_8)
        ])
      ])
    ])), [
      [_vShow, _ctx.html.length && _ctx.previewLoaded]
    ]),
    (_ctx.html.length && !_ctx.previewLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_app_loader)
        ]))
      : _createCommentVNode("", true),
    (_ctx.qrcodeModalOpen)
      ? (_openBlock(), _createBlock(_component_app_modal, {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.qrcodeModalOpen = false)),
          size: "w-100"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.qrCode.length)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.qrCode,
                    alt: "QRCode",
                    class: "w-28 mb-5"
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("components.mails.previewContent.qrCodeModalText")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}